import { render, staticRenderFns } from "./YtdLevel2.vue?vue&type=template&id=e5d5b4ec&scoped=true"
import script from "./YtdLevel2.vue?vue&type=script&lang=js"
export * from "./YtdLevel2.vue?vue&type=script&lang=js"
import style0 from "./YtdLevel2.vue?vue&type=style&index=0&id=e5d5b4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5d5b4ec",
  null
  
)

export default component.exports